import starsMp4 from "../../assets/images/stars-background.mp4";
import starsWebm from "../../assets/images/stars-background.webm";
import lamppost from "../../assets/images/lamppost.webp";
import { FullScreenImage } from "../Image/FullScreenImage";
import "./Entry.css";
import handshake from "../../assets/images/handshake.webp";
import handshake2 from "../../assets/images/handshake2.webp";
import { CSSProperties, useCallback, useEffect, useState } from "react";
import { AlternatingImage } from "../alternatingImages/AlternatingImages";
import { ScrollingVideo } from "../scrollingImage/ScrollingVideo";
import { Button } from "../button/Button";
import { CustomCursor } from "../customCursor/CustomCursor";
import cursorNormal from "../../assets/cursors/cursor-normal.webp";
import cursorHand from "../../assets/cursors/cursor-hand.webp";
import { useNavigate } from "react-router";
import { EntryTransition } from "./EntryTransition";

export const Entry = () => {
  const [nextPage, setNextPage] = useState('')
  const [showTransition, setShowTransition] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    if(nextPage && !showTransition) {
      navigate(nextPage);
    } else if (showTransition) {
      setTimeout(() => {
        setShowTransition(false);
      }, 1400)
    }
  }, [nextPage, showTransition, navigate]);

  const lamppostStyles: CSSProperties = {
    position: "absolute",
    top: "-200px",
    left: "30%",
    transform: "translateX(-30%)",
    width: "2400px",
    height: "auto",
    zIndex: 0,
  };

  const handshakeStyles = {
    position: "absolute" as const,
    bottom: "10%",
    left: "50%",
    transform: "translateX(-50%)",
    width: "900px",
    height: "600px",
    zIndex: 2,
  };

  const gradientOverlayStyle = {
    position: "fixed" as const,
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    background:
      "linear-gradient(to bottom, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.9) 90%, rgba(0, 0, 0, 1) 100%)",
    zIndex: 2,
    pointerEvents: "none" as const,
  };

  const buttonStyle: React.CSSProperties = {
    position: "relative" as const,
    left: '44vw',
    top: '49vh',
    zIndex: 3,
    width: '160px',
    height: '120px',
    borderRadius: '45%',
    opacity: '0',
    cursor: 'pointer',
    transition: 'transform 0.3s ease'
  };

  const handleEnterClick = useCallback((to: string) => {
    setShowTransition(true);
    setNextPage(to);
  }, []);

  return (
    <>
      <CustomCursor
        hoverTargetClass="enter-button"
        normalImage={cursorNormal}
        hoverImage={cursorHand}
      />
      <FullScreenImage
        src={lamppost}
        extraStyles={lamppostStyles}
        alt="A lamppost casts a golden glow"
      />
      <AlternatingImage
        style={handshakeStyles}
        frameUrls={[handshake, handshake2]}
      />
      <ScrollingVideo
        videos={[
          {
            mp4Src: starsMp4,
            webmSrc: starsWebm,
            alt: "The stars glimmer brightly",
          },
          {
            mp4Src: starsMp4,
            webmSrc: starsWebm,
            style: { transform: "rotate(180deg)" },
            alt: "The stars shimmer brightly",
          },
          {
            mp4Src: starsMp4,
            webmSrc: starsWebm,
            alt: "The stars shine brightly",
          },
        ]}
      />
      <div style={gradientOverlayStyle}></div>
      <Button to='/Home' value='' style={buttonStyle} className="enter-button" handleClick={handleEnterClick} />
      { showTransition ? <EntryTransition /> : undefined }
    </>
  );
};
